var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.iconDark ? _c('div', {
    ref: "friend",
    staticClass: "friend"
  }, [_c('div', {
    staticClass: "container",
    style: {
      backgroundImage: `url(${_vm.iconDark})`
    }
  }, [_c('div', {
    staticClass: "container-left",
    on: {
      "click": function ($event) {
        return _vm.jumpUrl(_vm.adsInfo.action_url, 1);
      }
    }
  }), _vm.adsInfo.btn_text ? _c('div', {
    staticClass: "moreText",
    on: {
      "click": function ($event) {
        return _vm.jumpUrl(_vm.adsInfo.btn_action_url, 2);
      }
    }
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v(_vm._s(_vm.adsInfo.btn_text))]), _c('div', {
    staticClass: "icon"
  })]) : _vm._e()])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };